export default {
  buttons: {
    create: 'Creează',
    update: 'Actualizează',
    cancel: 'Anulează',
  },
  fields: {
    title: {
      label: 'Titlu',
      placeholder: 'Introduceți titlul',
    },
    description: {
      label: 'Descriere',
      placeholder: 'Introduceți descrierea',
    },
    button_text: {
      label: 'Text buton',
      placeholder: 'Introduceți textul butonului',
    },
    button_url: {
      label: 'URL buton',
      placeholder: 'https://example.com',
    },
    image: {
      label: 'Imagine',
    },
  },
  title: 'Creează postare',
};
